<template lang="pug">
  //- Barra de filtros de búsqueda
  .b2b-filters
    b2b-search-bar
      div.block(slot='header')
        span.dateHeader {{ $t('ocr.filters.creation_date.value') }}
        //- Filtro de fechas
        ods-date-picker(
          v-model='dateTimePickerValue',
          type='datetimerange',
          :picker-options='pickerOptions2',
          @change='getDateTimePickerValue',
          :range-separator='$t("msg_generics.datepicker.separator")',
          :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
          :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
          :format='$t("date_format_long_datepicker")',
          :canSelectSeconds='true',
          :clearable='false',
          clearIcon='',
          :default-time="['00:00:00', '23:59:59']",
          prefix-icon='prefix-icon-date-time-picker',
          :showFooterButtons='true',
          align='right')
        //- Botón de actualizar resultados:
        ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom')
          ods-button(
            icon='ods-icon-refresh',
            size='medium',
            circle,
            @click="activeRefreshResults")

      div(slot='body')
        ods-form.b2b-filters__area(
          :model='filterForm',
          :rules='rules',
          ref='filterForm',
          @submit.native.prevent='')
          ods-form-item.first-input(prop='firstValue')
            ods-select(
              ref='filterBy',
              :no-match-text='$t("msg_generics.no_match")',
              v-model='filterForm.firstValue',
              :placeholder='$t("msg_generics.advanced_search")',
              @change='getFirstValue')
              ods-option(
                v-for='option in options',
                :key='option.col',
                :label='$t(option.value)',
                :disabled='option.selected',
                :value='option')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              //- Select type
              div(v-if="(selected.componente === 'select')")
                ods-form-item.others-input(prop='secondValueSelect')
                  ods-select(v-if='selected.prop === "idProject"',
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.name',
                      :value='option.id')
                  ods-select(v-else-if='selected.prop === "idDocumentType"',
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label="$t('auditory_doc_type.' + option.code)",
                      :value='option.id')
                  ods-select(v-else-if='selected.prop === "idMailServer"',
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.mailFrom',
                      :value='option.id')
                  ods-select(v-else-if='selected.prop === "idStatusDocument"',
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label="$t('invoice_status.' + option.status)",
                      :value='option.id')
                  ods-select(v-else,
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.code',
                      :value='option')
              //- Input type
              div(v-else-if="selected.componente === 'input' && selected.tipo === 'string'")
                ods-form-item.others-input(prop='secondValue')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValue',
                    @input='getSecondValue')
              //- Date Type
              div(v-else-if='selected.componente === "date"')
                ods-date-picker(
                  v-model='filterDatePickerValue',
                  type='daterange',
                  :picker-options='pickerOptions2',
                  @change='getDateRangePickerValue',
                  :range-separator='$t("msg_generics.datepicker.separator")',
                  :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                  :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                  :format='$t("date_format_calendar")',
                  prefix-icon='prefix-icon-date-time-picker',
                  align='right')
              div(v-else)
                ods-form-item.others-input(prop='secondValueNumber')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model.number='filterForm.secondValueNumber',
                    @input='getSecondValue')
          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              ods-button(
                :disabled="!activeButtonAddFilter",
                icon='ods-icon-plus',
                size='medium',
                circle,
                @click.native='onSubmit("filterForm")')
    .b2b-filters__container(v-if='listSelectedFiltersOcrDocuments.length > 0')
      transition-group.b2b-filters__group(
        name='ods-fade-in-linear',
        tag='div')
        ods-popover(
          key='icon-delete-filters',
          placement='top-start',
          trigger='hover',
          :content='$t("msg_generics.popover_clean_filters")')
          ods-button.clean-filters(
            slot='reference',
            type='neutral',
            size='small',
            icon='ods-icon-delete'
            @click='handleDeleteAllFilters')

        .b2b-filters__button(
          v-for='(filter, index) in listSelectedFiltersOcrDocuments',
          :key='index')
          b2b-filter-button-ocr-documents(
            :filter='filter',
            @closeTag='resetSelectedOneOption')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import router from '@/router/index'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonOcrDocuments from '@/views/facturas/ocrDocument/B2bFilterButtonOcrDocuments'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-ocr-documents',

  mixins: [Utils],

  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },

  data () {
    const _this = this
    return {
      activeButtonAddFilter: true,
      userLoggedOneProjectOneParty: false, // Flag que nos indica si el usuario tiene 1 solo proyecto y una sola empresa
      userLoggedOneProjectOnePartyOneCentre: false, // Flag que nos indica si el usuario tiene 1  proyecto 1 empresa 1 centro
      // DatePicker
      dateTimePickerValue: [],
      tid: null,
      filterDatePickerValue: [],
      pickerOptions2: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },
      // Formulario
      filterForm: {
        firstValue: '',
        secondValue: '',
        secondValueNumber: '',
        secondValueSelect: ''
      },
      selected: {},
      selectedFilters: [],
      options: {},
      // Reglas Validación
      rules: {
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 3, message: this.$t('msg_generics.min_three_letters') }
        ],
        secondValueNumber: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { type: 'number', message: this.$t('msg_generics.number_required') }
        ],
        secondValueSelect: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'queryOcrDocuments',
      'listSelectedFiltersOcrDocuments',
      'optionsFilterService', // OK
      'optionsFilterOcrDocumentsDocumentType', // OK
      'optionsFilterOcrDocumentsMailServer', // OK
      'optionsFilterOcrDocumentsStatus' // OK
    ])
  },

  watch: {
    '$route' (to) {
      this.listSelectedFiltersOcrDocuments = this.listSelectedFiltersOcrDocuments // eslint-disable-line
    }
  },

  components: {
    B2bSearchBar,
    B2bFilterButtonOcrDocuments
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getOcrDocuments', // Query de documentos OCR
      'queryOcrDocumentsState',
      'listSelectedFiltersOcrDocumentsState',
      'loadFilterOcrDocumentType', // query filtro DOCUMENT_TYPE
      'loadFilterOcrDocumentMailServer', // query filtro MAIL_SERVER
      'loadFilterStatusDocumentByType', // query filtro STATUS_DOCUMENT
      'optionsFilterInvoiceDraftSellerState'
    ]),

    disabledDate (time) {
      return time.getTime() > Date.now()
    },

    async getFirstValue (data) {
      this.filterForm.secondValue = ''
      this.filterForm.secondValueSelect = ''
      this.$refs.filterForm.clearValidate()
      this.selected = data
    },

    getSecondValue (data) {
      if (this.selected.componente === 'select') {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        switch (this.selected.prop) {
          case 'idProject':
            this.selected.labelText = option.name
            break
          case 'idDocumentType':
            this.selected.labelText = this.$t('auditory_doc_type.' + option.code)
            break
          case 'idMailServer':
            this.selected.labelText = option.mailFrom
            break
          case 'idStatusDocument':
            this.selected.labelText = this.$t('invoice_status.' + option.status)
            break
          default:
            break
        }
      } else if (this.selected.componente === 'date') {
        this.selected.labelText = data.query
      } else if (this.selected.componente === 'input') {
        this.selected.query = data
        this.selected.labelText = data
      } else {
        this.selected.query = data.id
        this.selected.labelText = data.code
        this.filterForm.secondValueSelect = data.code
      }

      this.$refs.filterForm.clearValidate()
    },

    onSubmit (formName) {
      this.$refs[formName].validate(async (valid) => {
        console.log('onSubmit FILTER: ', valid)
        if (valid) {
          const dataQuery = {
            query: {}
          }
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const column = this.selected.prop
            switch (column) {
              case 'idProject':
                console.log('idProject: ', this.selected.query)
                this.queryOcrDocuments.projectId = this.selected.query
                break
              case 'idDocumentType':
                this.queryOcrDocuments.documentTypeId = this.selected.query
                break
              case 'idStatusDocument':
                this.queryOcrDocuments.statusDocumentId = this.selected.query
                break
              case 'idMailServer':
                this.queryOcrDocuments.mailServerId = this.selected.query
                break
              case 'documentName':
                this.queryOcrDocuments.documentName = this.selected.query.trim()
                break
              case 'documentNumber':
                this.queryOcrDocuments.documentNumber = this.selected.query.trim()
                break
              case 'emailFrom':
                this.queryOcrDocuments.emailFrom = this.selected.query.trim()
                break
              case 'cretionDateTime':
                this.queryOcrDocuments.creationDateTimeFrom = this.selected.query[0]
                this.queryOcrDocuments.creationDateTimeTo = this.selected.query[1]
                this.filterDatePickerValue = []
                break
              case 'ocrProcessDate':
                this.queryOcrDocuments.ocrProcessDateFrom = this.selected.query[0]
                this.queryOcrDocuments.ocrProcessDateTo = this.selected.query[1]
                this.filterDatePickerValue = []
                break
              default:
                break
            }

            this.selectedFilters = this.listSelectedFiltersOcrDocuments

            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersOcrDocumentsState(this.selectedFilters)

            this.selected = {}
            this.$refs[formName].resetFields()

            this.queryOcrDocuments.page = 0
            await this.queryOcrDocumentsState(this.queryOcrDocuments)
            dataQuery.query = this.queryOcrDocuments

            const ocrDocuments = await this.getOcrDocuments(dataQuery)
            this.totalResults = ocrDocuments.data.totalElements
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.handleDeleteAllFilters()
          } finally {
            this.initForm()
            load.close()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // Emite el Evento al Padre con los nuevos Datos de la Fecha
    async getDateTimePickerValue () {
      console.log('getDateTimePickerValue: ', this.dateTimePickerValue)
      if (!this.dateTimePickerValue) {
        this.dateTimePickerValue = []
        this.dateTimePickerValue.push(this.queryOcrDocuments.creationDateTimeFrom)
        this.dateTimePickerValue.push(this.queryOcrDocuments.creationDateTimeTo)
      } else {
        this.queryOcrDocuments.creationDateTimeFrom = this.dateTimePickerValue[0]
        this.queryOcrDocuments.creationDateTimeTo = this.dateTimePickerValue[1]
        const dataQuery = {
          query: {}
        }
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.filter_date')
        })
        try {
          await this.queryOcrDocumentsState(this.queryOcrDocuments)
          dataQuery.query = this.queryOcrDocuments

          const ocrDocuments = await this.getOcrDocuments(dataQuery)
          this.totalResults = ocrDocuments.data.totalElements
        } catch (error) {
          console.log('getDateTimePickerValue FILTER CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Acción para refrescar los resultados
    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.queryOcrDocumentsState(this.queryOcrDocuments)
        dataQuery.query = this.queryOcrDocuments
        const ocrDocuments = await this.getOcrDocuments(dataQuery)
        this.totalResults = ocrDocuments.data.totalElements
      } catch (error) {
        console.log('refreshResults FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Filtro Fechas
    getDateRangePickerValue () {
      console.log('FILTRO SELECCIONADO ', this.selected)
      console.log('getDatePickerValue: ', this.filterDatePickerValue)

      this.selected.query = this.filterDatePickerValue
      // this.filterForm.secondValueSelect = this.selected
      this.getSecondValue(this.selected)
    },

    async handleDeleteAllFilters () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })
      try {
        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)
        await this.listSelectedFiltersOcrDocumentsState([])
        this.selectedFilters = this.listSelectedFiltersOcrDocuments.map(
          item => {
            item.labelText = ''
            item.query = ''
            item.selected = false
            return item
          }
        )
        if (!this.dateTimePickerValue) {
          this.queryOcrDocuments.creationDateTimeFrom = ''
          this.queryOcrDocuments.creationDateTimeTo = ''
        } else {
          this.queryOcrDocuments.creationDateTimeFrom = this.dateTimePickerValue[0]
          this.queryOcrDocuments.creationDateTimeTo = this.dateTimePickerValue[1]
        }
        this.queryOcrDocuments.documentTypeId = ''
        this.queryOcrDocuments.statusDocumentId = ''
        this.queryOcrDocuments.mailServerId = ''
        this.queryOcrDocuments.documentName = ''
        this.queryOcrDocuments.documentNumber = ''
        this.queryOcrDocuments.emailFrom = ''
        this.queryOcrDocuments.ocrProcessDateFrom = ''
        this.queryOcrDocuments.ocrProcessDateTo = ''

        await this.queryOcrDocumentsState(this.queryOcrDocuments)
        dataQuery.query = this.queryOcrDocuments
        const ocrDocuments = await this.getOcrDocuments(dataQuery)
        this.totalResults = ocrDocuments.data.totalElements
      } catch (error) {
        console.log('getOcrDocuments CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        // Reiniciamos el formulario
        this.initForm()
        load.close()
      }
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersOcrDocumentsState(data.listAfterRemove)
      this.initForm()
    },

    // Metodo que nos indica el numero de proyectos-empresas y centros de un usuario
    getProjectPartiesCentres () {
      let numParties = 0
      let numProject = 0
      let numCentres = 0
      if (this.activeUser.data && this.activeUser.data.projects) {
        numProject = this.activeUser.data.projects.length

        // Si el usuario logeado pertenece a un solo proyecto
        if (numProject === 1) {
          if (this.activeUser.data.projects[0].parties) {
            numParties = this.activeUser.data.projects[0].parties.length
          }
          // Si tiene una sola empresa vendedora
          if (numParties === 1 && this.activeUser.data.projects[0].parties[0].seller) {
            const vendedor = {
              id: this.activeUser.data.projects[0].parties[0].id,
              tradeName: this.activeUser.data.projects[0].parties[0].name
            }
            // seteamos la empresa en el campo vendedor
            const lstSeller = []
            lstSeller.push(vendedor)
            this.optionsFilterInvoiceDraftSellerState(lstSeller)
            // Activamos a true
            this.userLoggedOneProjectOneParty = true
            this.queryOcrDocuments.sellerId = vendedor.id

            // Si tiene un solo proyecto-centro y empresa
            if (this.activeUser.data.projects[0].parties[0].centres) {
              numCentres = this.activeUser.data.projects[0].parties[0].centres.length
              if (numCentres === 1) {
              // Activamos a true
                this.userLoggedOneProjectOnePartyOneCentre = true
              }
            }
          }
        }
      }
    },

    initForm () { // OK
      if (!this.options.document_name.selected) { // filtro document_name por defecto
        this.filterForm.firstValue = this.options.document_name
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
    },

    async getNotificationErrorMessage (error) {
      const statusCode = error.status
      let errorSms = ''
      switch (statusCode) {
        case 400:
          if (error.data.message === undefined) {
            errorSms = this.$t('error.e400')
          } else {
            errorSms = error.data.message
          }
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    // Creamos una copia del json que contiene los datos de los filtros y trabajamos con la copia
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersOcrDocuments)

    // Si el usuario sólo tiene un servicio, quitamos el filtro de servicios
    if (this.optionsFilterService.length < 2) {
      delete this.options.servicio
    }
    this.initForm()

    this.getProjectPartiesCentres()
    if (this.queryOcrDocuments.creationDateTimeFrom) {
      this.dateTimePickerValue.push(this.queryOcrDocuments.creationDateTimeFrom)
      this.dateTimePickerValue.push(this.queryOcrDocuments.creationDateTimeTo)
    }
    try {
      await this.queryOcrDocumentsState(this.queryOcrDocuments)
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  updated () {
    // Actualizamos las opciones de los filtros
    if (this.optionsFilterService.length > 1) {
      this.options.servicio.options = this.optionsFilterService
    }
    this.options.document_type.options = this.optionsFilterOcrDocumentsDocumentType
    this.options.mail_server.options = this.optionsFilterOcrDocumentsMailServer
    this.options.status_document.options = this.optionsFilterOcrDocumentsStatus

    console.log('updated filter options after load services data: ', this.options)
  }
}
</script>

<style lang="scss" scoped>
// BMG Tags centered into the status input into the container
::v-deep .ods-select__tags {
  margin-top: rem(20) !important;
  max-width: none !important;
}
::v-deep .b2b-filters__area .ods-form-item input {
  margin-bottom: rem(20) !important;
  height: 32px !important;
}
::v-deep .ods-select .ods-input.is-focus .ods-input__inner {
  height: 32px !important;
}
::v-deep .ods-input__prefix {
  height: 72px;
}
.b2b-filters {
  ::v-deep .ods-input__suffix {
    height: 72px;
  }
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  // background-color: var(--color-bg-primary);
  // border-top: .1rem solid $grey-2;
  // box-shadow: 0 0.2rem 0.8rem 0 rgba(0, 0, 0, 0.08);

  .dateHeader{
    font-size: 12px;
    padding: 0 28px 0 0px;
    color: var(--color-txt-secondary);
  }

  .ods-button {
    display: inline;
    margin-right: rem(24);  }

  .ods-form-item {
    .info {
      font-size: 18px;
      font-weight: 500;
      color: #060E14;
      text-transform: capitalize;
      margin-bottom:'0px';
    }
  }

  .ods-form-item.upload-attachment{
    margin-bottom: 12px;
  }

  .ods-form-item.labelAttachments{
    margin-bottom: 0px;
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }
    .ods-form-item__label {
      display: none
    }
    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
  ::v-deep .ods-select .ods-tag {
    margin: 2px 0 -56px 6px;
  }
}
</style>
